import { render, staticRenderFns } from "./dataAlarm.vue?vue&type=template&id=010412dc&"
import script from "./dataAlarm.vue?vue&type=script&lang=js&"
export * from "./dataAlarm.vue?vue&type=script&lang=js&"
import style0 from "./dataAlarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports